"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var IconHeader_1 = require("../../../../../../shared/core/components/IconHeader/IconHeader");
var AccountSummaryUI_styled_1 = require("../AccountSummaryUI.styled");
var Loading = function () {
    var _a = (0, core_1.useComponents)(), Card = _a.Card, SkeletonCTA = _a.SkeletonCTA, Margin = _a.Margin, SkeletonText = _a.SkeletonText;
    return (react_1.default.createElement(AccountSummaryUI_styled_1.FlexChild, { as: Card, "data-testid": "account-info-loading" },
        react_1.default.createElement(Margin, { bottom: [4, 8] },
            react_1.default.createElement(IconHeader_1.SkeletonIconHeader, null)),
        react_1.default.createElement(SkeletonText, { lines: 3 }),
        react_1.default.createElement(SkeletonCTA, null)));
};
exports.Loading = Loading;
